import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';

import { RootState } from 'src/app/reducers';
import { Log } from 'src/app/utils/log';
import { dispatchInfoMessage, dispatchAppError } from 'src/app/actions/core.actions';
import { enter } from '../../../resources/animations';
import { getDeleteDaigakuResult } from 'src/app/selectors/daigaku.selectors';
import { deleteDaigaku, initializeDeleteDaigakuState } from 'src/app/actions/daigaku.actions';

export interface DeleteDaigakuDialogData {
  id: string;
  daigakuCode: string;
  daigakuName: string;
}

@Component({
  selector: 'app-delete-daigaku-dialog',
  templateUrl: './delete-daigaku-dialog.component.html',
  styleUrls: ['./delete-daigaku-dialog.component.scss'],
  animations: [enter]
})
export class DeleteDaigakuDialogComponent {
  disabled = false;
  private LOG_SOURCE = this.constructor.name;

  constructor(
    private store: Store<RootState>,
    private dialogRef: MatDialogRef<DeleteDaigakuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteDaigakuDialogData
  ) {}

  deleteDaigaku() {
    if (!this.data || !this.data.id) {
      Log.warn(this.LOG_SOURCE, `dialog.data または data.id が設定されていません: `, this.data);
      return;
    }

    this.disableForms();

    Log.debug(this.LOG_SOURCE, `大学を削除します`);
    this.store
      .select(getDeleteDaigakuResult)
      .pipe(
        filter(it => it != null),
        take(1)
      )
      .subscribe(result => {
        this.store.dispatch(initializeDeleteDaigakuState());
        if (result.success) {
          const message = `${this.data.daigakuName} の削除が完了しました`;
          this.store.dispatch(dispatchInfoMessage({ message }));
          Log.debug(this.LOG_SOURCE, `大学削除完了: `, this.data);
          this.dialogRef.close(true);
        } else {
          Log.error(this.LOG_SOURCE, `大学削除でエラーが発生しました: `, JSON.stringify(result.error));
          this.store.dispatch(dispatchAppError({ source: this.LOG_SOURCE, error: result.error }));
          this.dialogRef.close(false);
        }

        this.enableForms();
      });
    this.store.dispatch(deleteDaigaku({ id: this.data.id }));
    this.store.dispatch(
      dispatchInfoMessage({
        message: `${this.data.daigakuName} を削除しています…`
      })
    );
  }

  cancel() {
    this.disableForms();
    this.dialogRef.close(false);
  }

  private disableForms() {
    this.disabled = true;
  }

  private enableForms() {
    this.disabled = false;
  }
}
